

























import Vue, { PropType } from 'vue';
import FieldInput from '@/components/form/FieldInput.vue';
import { getMultipleFieldInit } from '@/configs/creativeConfigs';
import { TCreativeMultipleField } from '@/types';

export default Vue.extend({
  name: 'MultipleFieldInput',
  components: { FieldInput },

  props: {
    value: {
      type: Array as PropType<Array<string>>,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    maxCount: {
      type: Number,
      required: false,
      default: 4,
    },
    maxSymbol: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  created() {
    let maxCount = this.maxCount;

    while (maxCount--) {
      this.fieldsData.push(getMultipleFieldInit());
    }

    this.input();
  },

  watch: {
    value: {
      handler(newValue: Array<TCreativeMultipleField>) {
        this.fieldsData = newValue;
      },
    },
  },

  methods: {
    change() {
      this.$emit('change', this.fieldsData);
    },
    input() {
      this.$emit('input', this.fieldsData);
    },
    checkValue(count: number): boolean {
      if (count === 1 || this.fieldsData[count - 2].value) {
        return true;
      } else {
        for (let i = count; i <= this.fieldsData.length; i++) {
          this.fieldsData[i - 1].value = '';
        }

        return false;
      }
    },
    resetErrors(field: TCreativeMultipleField) {
      if (field.errors.length) {
        field.errors = [];
      }
    },
  },

  data() {
    return {
      fieldsData: [] as Array<TCreativeMultipleField>,
    };
  },
});
